import { z } from "zod";
export const PlaceSuggestionsQuerySchema = z.object({
    timezone: z
        .string()
        .min(1)
        .max(100)
        .refine((value) => {
        try {
            return (
            // Bare abbreviations such as CET differ between Intl and Postgres.
            (value === "UTC" || /^[A-Za-z_]+(?:\/[A-Za-z0-9_+-]+)+$/.test(value)) &&
                Boolean(new Intl.DateTimeFormat("en", { timeZone: value }).resolvedOptions().timeZone));
        }
        catch {
            return false;
        }
    }, "Expected UTC or a slash-qualified IANA timezone"),
});
export const PlaceSuggestionSchema = z.object({
    placeId: z.string(),
    // Reload correction context and require its placeId to equal this suggestion's
    // placeId before confirming. A fresh token alone could rename a reassigned place.
    visitId: z.string(),
    latitude: z.number(),
    longitude: z.number(),
    label: z.string().nullable(),
    formattedAddress: z.string().nullable(),
    visitCount: z.number().int(),
    qualifyingDays: z.number().int(),
    hours: z.number(),
});
export const PlaceSuggestionsSchema = z.object({
    home: PlaceSuggestionSchema.nullable(),
    work: PlaceSuggestionSchema.nullable(),
});
export const SnoozePlaceSuggestionInputSchema = z.object({ role: z.enum(["home", "work"]) });
export const SnoozePlaceSuggestionResultSchema = z.object({
    role: z.enum(["home", "work"]),
    snoozedUntil: z.string().datetime(),
});
//# sourceMappingURL=place-suggestions.js.map